import { render, staticRenderFns } from "./BlockBlogListUser.vue?vue&type=template&id=10391cbd&scoped=true&"
import script from "./BlockBlogListUser.vue?vue&type=script&lang=js&"
export * from "./BlockBlogListUser.vue?vue&type=script&lang=js&"
import style0 from "./BlockBlogListUser.vue?vue&type=style&index=0&id=10391cbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10391cbd",
  null
  
)

export default component.exports